import React, { useState } from 'react';
import Modal from './Modal';
import ContactForm from './ContactForm';
import QuestionForm from './QuestionForm';

const CallToAction = () => {
  const [showContactModal, setShowContactModal] = useState(false);
  const [showQuestionModal, setShowQuestionModal] = useState(false);
  
  const handlePrimaryClick = () => {
    setShowContactModal(true);
  };

  const handleSecondaryClick = () => {
    setShowQuestionModal(true);
  };

  const closeContactModal = () => {
    setShowContactModal(false);
  };

  const closeQuestionModal = () => {
    setShowQuestionModal(false);
  };

  return (
    <>
      <section className="cta">
        <div className="cta-container">
          <h2>Ready to turn AI from an idea to a working system?</h2>
          <p>
            Whether you're starting from strategy or need an extra set of hands to get an existing project over the finish line, 
            SolidlyAI brings the expertise to deliver the results you need.
          </p>
          <div className="cta-buttons">
            <button 
              className="btn btn-primary"
              onClick={handlePrimaryClick}
            >
              Request a meeting →
            </button>
            <button 
              className="btn btn-secondary"
              onClick={handleSecondaryClick}
            >
              Ask a question
            </button>
          </div>
          <p className="cta-guarantee">
            Free initial consultation.
          </p>
        </div>
      </section>

      <Modal 
        isOpen={showContactModal} 
        onClose={closeContactModal}
        title="Request a Meeting"
      >
        <ContactForm onClose={closeContactModal} />
      </Modal>

      <Modal 
        isOpen={showQuestionModal} 
        onClose={closeQuestionModal}
        title="Ask a Question"
      >
        <QuestionForm onClose={closeQuestionModal} />
      </Modal>
    </>
  );
};

export default CallToAction;